import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
  },
  switchButton: {
    width: '418px',
    height: '40px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '140%',
    letterSpacing: '-0.02em',
    border: `1px solid ${alpha(theme.palette.primary.main, 0.28)}`,
    boxShadow: `0px 8px 18px ${alpha(theme.palette.extendedGrey.darker, 0.14)}`,
    '&:hover': {
      backgroundColor: theme.palette.surface.raised,
    },
  },
  layout: {
    backgroundColor: theme.palette.background.default,
    backgroundImage: "url('/overlay.jpg'), url('/bg.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
}));
